import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from 'react-query'
import { ThemeProvider } from './theme/context/ThemeContext'
import { ThemeProvider as HeroThemeProvider } from '@conexasaude/conexa-hero'
import { AuthProvider } from './contexts/Auth'
import queryClient from './services/queryClient'
import { ReactQueryDevtools } from 'react-query/devtools'
import App from './App'
import './i18n'
import '@/services/sentry'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <HeroThemeProvider theme="cnx">
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <ThemeProvider>
              <div className="appContainer">
                <App />
              </div>
            </ThemeProvider>
          </AuthProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </BrowserRouter>
    </HeroThemeProvider>
  </React.StrictMode>,
)
